/* import __COLOCATED_TEMPLATE__ from './conversation-list.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { ConversationExploreConversation } from './conversation-panel';
import type { DrillInConversationCard } from 'embercom/components/reporting/custom/drill-in-card-view';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
interface Args {
  conversationExploreConversations: ConversationExploreConversation[] | DrillInConversationCard[];
  onConversationSelected: (conversationId: number) => void;
  selectedConversationId: number;
  hasMoreConversations: boolean;
  loadMoreConversations: () => void;
  isLoadingMore: boolean;
}

export default class ConversationList extends Component<Args> {
  @tracked isHovered = false;
  scrollContainer: HTMLElement | null = null;

  @action
  setupScrollContainer(element: HTMLElement) {
    this.scrollContainer = element;
    this.scrollToSelectedConversation();
  }

  @action
  scrollToSelectedConversation() {
    if (!this.scrollContainer || !this.args.selectedConversationId) {
      return;
    }

    let selectedElement = this.scrollContainer.querySelector(
      `[data-conversation-id="${this.args.selectedConversationId}"]`,
    ) as HTMLElement;

    if (selectedElement) {
      selectedElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::ConversationList': typeof ConversationList;
  }
}
